import { Flex } from "@chakra-ui/react";

import { HEIGHT as HEADER_HEIGHT } from "app/components/Header";
import { Spinner } from "ui/Spinner/Spinner";

export function BatteryTasksLoading() {
  return (
    <Flex
      position="absolute"
      top={0}
      left={0}
      zIndex={20}
      w="full"
      minH={`calc(100vh - ${HEADER_HEIGHT})`}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      gap="s200"
      bgColor="rgba(255, 255, 255, 0.90)"
    >
      <Spinner />
    </Flex>
  );
}
